export interface MovieCategory {
  id: string;
  name: string;
  description: string;
  icon: string;
}

export const categories: MovieCategory[] = [
  {
    id: "urban",
    name: "都市情欲",
    description: "霓虹都市中的情感纠葛与暧昧夜色，聚焦现代男女的爱欲与挣扎。",
    icon: "ri-building-line",
  },
  {
    id: "costume",
    name: "古装风情",
    description: "穿越古今的绮丽画卷，深宅大院与宫廷秘事交织的风情故事。",
    icon: "ri-vip-diamond-line",
  },
  {
    id: "thriller",
    name: "悬疑禁忌",
    description: "层层反转的禁忌谜题，在欲望与危险之间步步惊心。",
    icon: "ri-eye-off-line",
  },
  {
    id: "classic",
    name: "经典回顾",
    description: "重温黄金年代的经典光影，历久弥新的情怀与魅力。",
    icon: "ri-history-line",
  },
  {
    id: "crime",
    name: "江湖罪爱",
    description: "灯红酒绿下的江湖恩怨，罪与爱在暗夜中纠缠。",
    icon: "ri-spy-line",
  },
  {
    id: "fantasy",
    name: "奇幻情迷",
    description: "月光与迷雾中的奇幻传说，超越现实的情迷故事。",
    icon: "ri-moon-line",
  },
];